import { render, staticRenderFns } from "./changePassword.vue?vue&type=template&id=23de5233&scoped=true&lang=pug"
import script from "./changePassword.vue?vue&type=script&lang=ts"
export * from "./changePassword.vue?vue&type=script&lang=ts"
import style0 from "./changePassword.vue?vue&type=style&index=0&id=23de5233&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23de5233",
  null
  
)

export default component.exports